module.exports = __webpack_public_path__ + "static/img/why-us.9f9d12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/why-us.png
// module id = 116
// module chunks = 1